import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const close: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  content: (
    <g id="close_w_o_saving_icon" data-name="close w/o saving icon" transform="translate(18459.691 2947.492)">
      <rect
        id="Rectangle_2788"
        data-name="Rectangle 2788"
        width="28"
        height="28"
        transform="translate(-18459.691 -2947.492)"
        fill="none"
      />
      <path
        id="Path_7085"
        data-name="Path 7085"
        d="M10.319,10.306a1.071,1.071,0,0,1,1.516,0l5.693,5.688,5.693-5.688a1.072,1.072,0,1,1,1.516,1.516L19.05,17.515l5.688,5.693a1.072,1.072,0,0,1-1.516,1.516l-5.693-5.688-5.693,5.688a1.072,1.072,0,0,1-1.516-1.516l5.688-5.693-5.688-5.693A1.071,1.071,0,0,1,10.319,10.306Z"
        transform="translate(-18462.846 -2950.552)"
        fill="currentColor"
      />
    </g>
  ),
};
